/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */

import worldEcharts from '@/components/app/worldMapEcharts/index.vue';

export default {
    name: 'sgatajtj',
    components: {worldEcharts},
    data() {
        return {
            // 涉外案件统计
            tableSwajtj: [],
            showTableSwajtj: [],
            currentPage: 0
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            // 这里写请求再调此方法
            const _this = this;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.szsjtj.selectSjtjSwgatajForSw,
                params: _this.$parent.searchData
            })
                .then((res) => {
                    _this.tableSwajtj = res.data;
                    _this.showTableSwajtj = res.data;
                    _this.getShowTableData();
                });
        },
        getShowTableData() {
            this.showTableSwajtj = this.tableSwajtj.slice(this.currentPage * 10, (this.currentPage + 1) * 10);
        },
        changePage(pageInfo) {
            this.currentPage = pageInfo.offset / pageInfo.limit;
            this.getShowTableData();
        }
    }
};

